// Libraries
import { action, computed, observable } from "mobx";

// Custom
import { BaseStore } from "./BaseStore";
import { Stores } from "../Stores";
import { PortalThemeModel, PortalThemeDto } from "Custom/Models/DashboardModels/PortalThemeModel";
import { isEmptyOrWhitespace } from "Core/Utils/Utils";

export class PortalThemeStore extends BaseStore {
    @observable public theme: PortalThemeModel = new PortalThemeModel();

    @observable public companySlug = "";

    @action public loadFromSessionStorage = () => {
        const companySlug = sessionStorage.getItem("companySlug");

        if (!companySlug) {
            return;
        }

        const storedTheme = sessionStorage.getItem(`portalTheme:${companySlug}`);

        if (!storedTheme) {
            return;
        }

        try {
            this.theme.fromDto(JSON.parse(storedTheme));
            this.companySlug = companySlug;
        } catch {
            // swallow - gulp
        }
    };

    @action public setTheme = (dto: PortalThemeDto) => {
        this.theme.fromDto(dto);
    };

    @action public clearSessionStorage = () => {
        if (this.companySlug) {
            sessionStorage.removeItem(`portalTheme:${this.companySlug}`);
        }
    };

    @computed public get companyLogo(): string {
        return this.theme.portalLogoUrl;
    }

    @computed public get canDisplayCompanyLogo(): boolean {
        return !isEmptyOrWhitespace(this.theme.portalLogoUrl);
    }

    @computed public get heroImageUrl(): string {
        return this.theme.heroImageUrl;
    }

    @computed public get primaryColour(): string {
        return this.theme.primaryColour;
    }

    @computed public get secondaryColour(): string {
        return this.theme.secondaryColour;
    }
}
